import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {submit, formValueSelector, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {MODALS} from 'ducks/tenancy';

import {calculateLineAmount, calculateTotals} from 'utils/money';

import {Totals, Buttons, CreditNoteCreateForm} from './components';

import './styles.css';

class CreditNoteCreateModal extends React.Component<any> {
  triggerFormSubmit = () => {
    this.props.dispatch(submit('creditNoteCreate'));
  };

  calculateLineAmount = () => {
    const {quantityValue, unitPriceValue, discountValue} = this.props.form;

    const quantity = Number(quantityValue || 0);
    const unitPrice = Number(unitPriceValue || 0);
    const discount = Number(discountValue || 0);

    return calculateLineAmount(quantity, unitPrice, discount);
  };

  calculateTotals = () => {
    const {taxRateValue} = this.props.form;

    const amount = this.calculateLineAmount();

    if (taxRateValue) {
      return calculateTotals(taxRateValue, Number(amount));
    }
    return {total: 0.0, subTotal: 0.0, subTotalVat: 0.0};
  };

  getExtraActions = ({scheduleType}) => {
    let extraActions = [
      ...this.props.closeModalExtraActions,
      ...this.props.refetchExtraActions({
        tenancyId: this.props.data.tenancyId,
        scheduleType
      })
    ];
    if (!_.isNil(this.props.closeModalSuccessExtraActions)) {
      extraActions.push(this.props.closeModalSuccessExtraActions);
    }

    return extraActions;
  };

  render() {
    const {
      data: {
        locationRef,
        tenancyId,
        primaryTenant,
        invoice,
        openFromBookingSet,
        booking
      },
      form: {submitting}
    } = this.props;

    const totals = this.calculateTotals();
    const subTotal = totals && totals.subTotal;
    const total = totals && totals.total;
    const subTotalVat = totals && totals.subTotalVat;

    const lineAmount = this.calculateLineAmount();

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="CreditNoteCreateModal"
        type={Modal.LARGE}>
        <Modal.Header>
          <h3 className="header">
            Create a Credit note
            {invoice && ` for invoice ${invoice.idString}`}
          </h3>
          <div className="subHeader">To {primaryTenant.fullName}</div>
        </Modal.Header>
        <Modal.Body>
          <CreditNoteCreateForm
            locationRef={locationRef}
            scheduleType={this.props.data.scheduleType}
            invoice={invoice}
            tenancyId={tenancyId}
            lineAmount={lineAmount}
            getExtraActions={this.getExtraActions}
            storeDataExtraActions={this.props.storeDataExtraActions}
            delayExtraActions={this.props.delayExtraActions}
            openFromBookingSet={openFromBookingSet}
            booking={booking}
          />
          <Totals subTotal={subTotal} total={total} subTotalVat={subTotalVat} />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const selector = formValueSelector('creditNoteCreate');
const mapStateToProps = state => {
  return {
    form: {
      quantityValue: selector(state, 'quantity'),
      unitPriceValue: selector(state, 'unitPrice'),
      discountValue: selector(state, 'discount'),
      taxRateValue: selector(state, 'taxRate'),
      submitting: isSubmitting('creditNoteCreate')(state)
    }
  };
};

export default connect(mapStateToProps)(withModal(MODALS.CREDIT_NOTE_CREATE)(
  CreditNoteCreateModal
) as React.ComponentType<any>);
